import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { BarChartCard } from "@/partner/shared/components/BarChartCard";
import type { CalendarIntervalValue } from "@/partner/shared/components/AnalyticsCalendarInterval";
import { useAnalyticsSalesByDateQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsSalesByDateChart: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [calendarInterval, setCalendarInterval] =
    useState<CalendarIntervalValue>();

  const { data, loading, error } = useAnalyticsSalesByDateQuery({
    fetchPolicy: "no-cache",
    variables: {
      filter: filter as never,
      calendarInterval: calendarInterval as never,
    },
  });

  return (
    <BarChartCard
      title={t("analytics.sales.chartSalesByDate")}
      chart={data?.analyticsSales.salesByDate}
      loading={loading}
      error={error}
      dateFrom={filter.dateFrom}
      dateTo={filter.dateTo}
      onChangeCalendarInterval={setCalendarInterval}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.SalesByDateType}
          filter={filter}
          variables={{ calendarInterval }}
        />
      }
    />
  );
};
